import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import {
  getSelectionRectangle
} from '../utilities';

export function setToolbarPosition(element, editorMainReference) {

  const selectionRectangle = getSelectionRectangle();

  const anchor = {
    getBoundingClientRect() {
      return selectionRectangle;
    }
  };
  const viewport = document.body;
  const horizontalOffset = 5;
  const verticalOffset = 5;
  const startSide = void 0;
  const placeOnCenter = true;
  const positionableSides = ['top', 'bottom'];

  // This is a experiment code to reduce width of the element
  // if the element does not fit inside the viewport. 
  const widthReduction = window.widthReduction || 30;
  let displayed = displayElementAroundAnchor(element, anchor, viewport, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);
  let iterations = 1;

  while (displayed === false && iterations < 10) {

    element.style.width = (element.getBoundingClientRect().width - widthReduction) + 'px';

    displayed = displayElementAroundAnchor(element, anchor, viewport, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

    iterations++;

  }

  element.style.height = 'auto';

  return displayed;

}